export class Company {

  public id?: number;
  public name?: string;
  public country?: string;
  public postalCode?: number;
  public city?: string;
  public address?: string;


  constructor (data?: any) {
    if (data) {
      this.id = data.id;
      this.name = data.name;
      this.country = data.country;
      this.postalCode = data.postalCode;
      this.city = data.city;
      this.address = data.address;
    }
    if (!this.country) {
      this.country = "Magyarország";
    }
  }

}
